/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ProductListingLayout.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
* By            : E807238
* On            : Nov 1, 2019
* Description   : ASDS-1673: Add To Cart Conformation UI & Integration
*
* By            : E844276
* On            : Nov 18, 2019
* Description   : Added generic product functionalities - removed from products
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes. Add to cart error handling.
 *
 * By            : H422336
 * On            : Oct, 22 2020
 * Description   : ASDS-3535 UI Enhancements for Phase-II
 *
******************************************************************************/
import React from 'react';
import { connect } from 'react-redux';
import ProductListing from './ProductListing/ProductListing';
import ProductListingActions from '../redux/actions/product-listing-actions';
import CategoryListingActions from '../redux/actions/category-listing-actions';

interface ProductListingLayoutProps {
    showAlertMsg: boolean;
    lastProdAddedToCart: string;
    getProductListing: Function;
    getCategoryListing: Function;
    isAddToCartSuccess: boolean;
}

interface ProductListingState {

}

/**
 * @author ASDS Team
 * @description Layout for Product Listing section.
 */
class ProductListingLayout extends React.PureComponent<ProductListingLayoutProps, ProductListingState> {

    componentDidMount() {
        this.props.getProductListing();
        this.props.getCategoryListing();
    }
    render() {
        return (
            <React.Fragment>
                <ProductListing />
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
   return {
        showAlertMsg: state.productAlertData.payload.showAlertMsg,
        lastProdAddedToCart: state.productAlertData.payload.lastProdAddedToCart,
        isAddToCartSuccess: state.productAlertData.payload.isAddToCartSuccess
    };
}

const mapDispatchToProps = {
    getProductListing: ProductListingActions.getProductsForListing,
    getCategoryListing: CategoryListingActions.getCategoryListing,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductListingLayout);